/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_appsync_graphqlEndpoint": "https://dy2alpin3jcifgk2psavu3s2hi.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_content_delivery_bucket": "coexistenceui-dev-hostingbucket-637289229284",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://dez1iz9s1dmta.cloudfront.net"
};


export default awsmobile;
